export enum TimeoutRequestConfigurationEnum {
  OneMinuteInMilliseconds = 60000,
  TwoMinutesInMilliseconds = 120000,
  ThreeMinutesInMilliseconds = 180000,
  FiveMinutesInMilliseconds = 300000,
  TenMinutesInMilliseconds = 600000,
  Default = 30000
}
